var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.921v39.694c0 1.61 1.361 2.92 3.034 2.92h18.932c1.673 0 3.034-1.31 3.034-2.92V9.92C45 8.311 43.639 7 41.966 7H23.034C21.361 6.998 20 8.308 20 9.921zm22.848 33.46H22.152V14.658h20.696v28.723zm-.882 7.08H23.034c-.486 0-.882-.379-.882-.846v-4.16h20.696v4.16c0 .467-.396.847-.882.847zm.882-40.54v2.665H22.152V9.921c0-.468.396-.85.882-.85h18.932c.486 0 .882.38.882.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.88 47.326h-2.76c-.718 0-1.299.533-1.299 1.192 0 .659.581 1.192 1.3 1.192h2.758c.719 0 1.3-.533 1.3-1.192.002-.656-.581-1.192-1.3-1.192z"
  }))));
};
export default SvgPhone;